export enum SCRAPE_STATUS_ITEM_TYPE {
  TOTAL = 'total',
  BANK = 'bank',
  HOMETAX = 'hometax',
  CARD = 'card',
}

export type ScrapeStatusItemStatus = 'success' | 'error' | 'inProgress' | 'notConnected';

export type ScrapeStatusItem = Record<
  SCRAPE_STATUS_ITEM_TYPE,
  {
    label: string;
    completedCount: number;
    totalCount: number;
    progressPercent: number;
    isAllCompleted: boolean;
    status: ScrapeStatusItemStatus;
  }
>;
